<template>
  <div class="modal-mask" @mousedown.self.stop="closeModal">
    <div class="modal" @click.stop @keyup-enter="saveItemInfo">
      <div class="modal__head">
        <h3 class="modal__title">{{ state.updatedId == null ? 'Создание записи' : 'Редактировать запись' }}</h3>
        <div class="close" @click.stop="closeModal">
          <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L16 16" stroke="currentColor" stroke-width="2"/>
            <path d="M1 16L16 1" stroke="currentColor" stroke-width="2"/>
          </svg>
        </div>
      </div>

      <div class="modal__body">
        <div class="page__row mb-20">
          <div class="page__item">
            <VSelect
              label="Объект"
              v-model="state.object"
              name="object"
              item-text="label"
              :items="objectList"
              :handler-search="GETLogisticObjectList"
              search
            />
          </div>

          <div class="page__item">
            <AppInput title="Количество времени (в часах)"
                      :value="state.amount_of_time"
                      :valid="state.validation.amount_of_time"
                      required
                      @value-changed="setItemTime"
                      @got-focus="clearValidation('amount_of_time')"
                      width="100%"
            />
          </div>
        </div>

        <div class="page__row mb-20">
          <div class="page__item" style="width: 100%;">
            <AppInput title="Ответственный"
                      :value="state.responsible"
                      @value-changed="setResponsible"
                      width="100%"
            />
          </div>
        </div>

        <div class="page__row mb-20">
          <div class="page__item" style="width: 100%;">
            <AppTextarea title="Комментарий"
                         :value="state.description"
                         @value-changed="setDescription"
            />
          </div>
        </div>

        <p style="color: #697178; margin-bottom: 20px; font-weight: 600">Тип рабочего времени</p>
          <AppRadio title="Обычный рабочий день"
                    name="workingTime"
                    style="margin-bottom: 10px;"
                    :checked="state.type_of_working_time === 1"
                    @toggle-check="setType(1)"
          />
          <AppRadio title="Выходной или праздничный день"
                    name="workingTime"
                    style="margin-bottom: 10px;"
                    :checked="state.type_of_working_time === 2"
                    @toggle-check="setType(2)"
          />
          <AppRadio title="Командировка"
                    name="workingTime"
                    style="margin-bottom: 10px;"
                    :checked="state.type_of_working_time === 3"
                    @toggle-check="setType(3)"
          />
        <div class="modal__button-wrap">
          <div class="modal__button">
            <AppButton :title="state.updatedId == null ? 'Создать' : 'Сохранить' " type="main" @click.native="saveItemInfo"/>
          </div>
          <div class="modal__button">
            <AppButton title="Отмена" type="alt" @click.native="closeModal"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppButton from '@/components/page/button/AppButton.vue'
import AppInput from '@/components/page/input/AppInput'
import AppTextarea from '@/components/page/input/AppTextarea'
import AppRadio from '@/components/page/input/AppRadio'
import { mapActions } from 'vuex'
import VSelect from '@/components/page/Form/VSelect'
import { mapObject } from '@/utils/page/logistic'

export default {
  name: 'LogisticWaybillWorkModal',
  components: {
    VSelect,
    AppRadio,
    AppTextarea,
    AppInput,
    AppButton
  },
  props: {
    state: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    objectList () {
      return this.$store.state.handbook.logistic.objectList.map(mapObject)
    }
  },
  mounted () {
    this.GETLogisticObjectList()
  },
  methods: {
    ...mapActions('handbook/logistic', {
      GETLogisticObjectList: 'GETLogisticObjectList'
    }),
    saveItemInfo () {
      this.$emit('save-item-info')
    },
    closeModal () {
      this.$emit('close-modal')
    },
    setItemTime (value) {
      this.$emit('set-item-time', value)
    },
    setObject (value) {
      this.$emit('set-item-object', value)
    },
    setResponsible (value) {
      this.$emit('set-item-responsible', value)
    },
    setDescription (value) {
      this.$emit('set-item-description', value)
    },
    setType (value) {
      this.$emit('set-item-type', value)
    },
    clearValidation (value) {
      this.$emit('clear-validation', value)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/system/_vars';
@import '../../assets/css/system/_mixins';

.modal {
  max-width: 910px;
  margin: 0 auto;

  &-mask {
    display: block;
    overflow: auto;
  }

  &__text {
    text-align: center;
    color: $font_color_second;
    margin-bottom: 20px;
  }

  &__button-wrap {
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
  }

  &__button {
    margin-right: 16px;
    margin-bottom: 10px;

    &:last-child {
      margin-right: 0;
    }
  }

  &__body {
    width: 100%;
  }
}

.page {
  &__item {
    width: 50%;
  }
}

::v-deep .radio {
  &__text {
    color: #697178;
  }
}

</style>
